<template>
	<div>
		<Header></Header>
		<Nav></Nav>
		<div class="ordercenter">
			<div class="order">
				<div class="order-list">
					<div class="ttshop-userights">
						<div class="ttshop-myorder clearfloat">
							<div class="ttshop-myorderseach">
								<input type="text" placeholder="请输入您的订单名称" v-model="order_txt" ref="order_txt">
								<button @click="lookupOrder()">搜索</button>
							</div>
						</div>
						<!-- 订单列表 -->
						<div class="ttshop-myorderlist">
							<div class="ttshop-myordertitle clearfloat">
								<div style="float:left;width:690px;" class="clearfloat">
									<div class="ttshop-myordertext">
										<div class="ttshop-myordertexter clearfloat">
											<div @click="getOrderList()">全部订单<img src="../../../assets/purchase/image/header/xiala.png"></div>
										</div>
									</div>
									<div class="ttshop-myorderdj">
										<p>单价</p>
									</div>
									<div class="ttshop-myorderdj">
										<p>数量</p>
									</div>
									<div class="ttshop-myorderdjs">
										<p>收货人</p>
									</div>
									<div class="ttshop-myorderzfje">
										<p>支付总金额</p>
									</div>
								</div>
								<div class="ttshop-myordercz">
									<p>操作</p>
								</div>
							</div>
							<!-- 暂无订单展示 -->
							<div v-show="list.length == 0">
								<div class="ttshop-myorderzw" v-show="finish">
									<img src="../../../assets/images/ttshop_zanwu.png" alt="">
									<p>暂无订单</p>
								</div>
							</div>
							<div class="ttshop-myordercon" v-for="(item,index) in order_list" v-model="index">
								<div class="ttshop-myorderconed clearfloat">
									<div class="ttshop-myordercontitle clearfloat">
										<p>{{item.addtime}}</p>
										<p>订单号：<span>{{item.order_no}}</span></p>
										<div class="ttshop-myordercontitle-right">
											<div>
												<p class="ttshop-over" v-if="item.apply_delete == 1">已取消</p>
												<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 0 && item.apply_delete == 0">待发货</p>
												<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 1 && item.is_confirm == 0">待收货</p>
												<p class="ttshop-over ttshop-over-adopt" v-if="item.is_confirm == 1">已收货</p>
											</div>
										</div>
									</div>
									<div class=" clearfloat d-flex orderlist">
										<div class="listitem">
											<div class="ttshop-myorderconlist clearfloat" v-for="(items,idx) in item.goods_list" :key="idx">
												<div class="ttshop-myorderconleft clearfloat">
													<div class="ttshop-orderimg">
														<img :src="items.goods_pic" alt="">
													</div>
													<div class="ttshop-ordertext">
														<h5>{{items.goods_name}}</h5>
														<span v-for="(attr,ids) in items.attr_list" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
													</div>

												</div>
												<div class="ttshop-myorderdj">
													<p>￥<span>{{items.price}}</span></p>
												</div>
												<div class="ttshop-myorderdj ttshop-myorderdjer">
													<p><span>{{items.num}}</span></p>
												</div>
												<div class="ttshop-shr">
													<p>{{item.consignee}}</p>
												</div>
												<div class="ttshop-zfzje">
													<p>￥<span>{{item.pay_price}}</span></p>
												</div>
											</div>
										</div>
										<div class="ttshop-caozuos d-flex  align-items-center justify-content-center">
											<div>
												<p class="ttshop-cztext" @click="orderDetails(index)">订单详情</p>
												<p class="ttshop-cztext" v-show="item.is_confirm == 1">已收货</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="ttshop-myorderpage clearfloat" v-show="order_list.length != 0">
								<el-pagination class="ttshop-pages" @current-change="handleCurrentChangeMyorder" :current-page.sync="myorder_page" background
								 layout="prev, pager, next" @prev-click="myorder_perv" @next-click="myorder_next" :page-count="order_list_num"></el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Nav from "@/components/purchase/nav/nav";
	import Footer from "@/components/purchase/footer/footer";
	import "./allorderlist.css";

	export default {
		components: {
			Header,
			Nav,
			Footer
		},
		data() {
			return {
				route_url: this.$store.state.route_url,
				enterprise_name: this.$store.state.qycg_user.nickname,
				list: [],
				finish: false,
				items: ['我的订单', '审批订单'],
				pageShow: true, //分页
				page_count: 0,
				page: 1,
				limit: 4,
				department_id: this.$route.query.id, //商品id, //部门id
				access_token: '', //用户登录唯一标识
				order_list: [], //订单列表
				order_txt:'',   //订单关键字查找
				myorder_page: 1,   //订单分页
				myorder_count: 6,  //订单分页
				order_list_num: 0,
			}
		},
		 computed: {
		            userdata:function(){
		                return this.order_list.slice((this.page)*this.page_count,this.page*this.page_count);
		            },
		        },
		created() {
			this.basicInformation();
			this.getOrderList();
			let that = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					if (that.$refs.order_txt.value) {
						that.getOrderList();
					}
				}
			};
		},
		methods: {
			// 获取基础信息
			basicInformation() {
				let user = this.$store.state.qycg_user;
				// this.department_id = user.department_id;
				this.access_token = this.$store.state.qycg_user.access_token;
				this.level = user.level;
				this.id = user.id;
			},
			//订单输入关键字查找
			lookupOrder(){
				this.getOrderList()
			},
			// 获取订单列表
			getOrderList() {
				// console.log(this.department_id)
				let dep_id = this.department_id;
				let access_token = this.access_token;
				let page = this.myorder_page;
				let limit = this.myorder_count;
				let keyword = this.order_txt;
				// console.log(dep_id)
				// console.log(access_token)
				// console.log(page)
				// console.log(limit)
				// console.log(keyword)
				this.$api.statisticsOrderList({
					shop_type: 'qycg',
					access_token: access_token,
					dep_id:dep_id,
					page:page,
					limit: limit,
					keyword: keyword,
				}).then((res) => {
					// console.log(res)
					this.order_list = res.data.list;
					this.page_count = res.data.page_count;
					this.finish = true;
					this.order_list_num = res.data.page_count;
					this.order_txt = '';
					if (res.data.page_count == 1) {
						this.pageShow = false;
					} else {
						this.pageShow = true;
					}
					if(this.order_list.length > 0){
						this.finish = false
					}
				}).catch((err) => {
					// console.log(err);
				});
			},
			//订单详情
			orderDetails(index){
				let orderId = this.order_list[index].order_id;
				this.$router.push("/" + this.route_url + "/orderdetails");
				this.$store.commit("orderDetailsId", orderId);
			},
			// 订单输入分页
			handleCurrentChangeMyorder(e) {
				this.myorder_page = e;
				this.common.backTop();
				this.getOrderList();
			},
			//订单上一页
			myorder_perv() {
				this.myorder_page--;
				this.common.backTop();
				this.getOrderList();
			},
			// 订单下一页
			myorder_next() {
				this.myorder_page++;
				this.common.backTop();
				this.getOrderList();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.ordercenter {
		width: 100%;
		min_height: 728px;
		_height: 728px;
		background: #F2F2F2;
		padding-top: 20px;

		.order {
			width: 1080px;
			// height: 733px;
			margin: 0 auto;
			background: #FFFFFF;
			display: flex;

			.order-left {
				width: 186px;
				height: 728px;
				box-sizing: border-box;
				border-right: 1px solid #F5F5F5;

				.order-title {
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: 12px;
					margin: 20px 0 14px 24px;
				}
			}

			.order-list {
				width: 894px;
				margin: 0 auto;
				// height: 733px;

				.ttshop-userights {
					padding: 16px 24px;
					box-sizing: border-box;
					background: #fff;

					.ttshop-myorder {
						width: 100%;
						margin-bottom: 16px;

						ul {
							float: left;

							li {
								float: left;
								font-size: 12px;
								color: #333;
								font-weight: 600;
								line-height: 12px;
								padding: 8px 0;
								box-sizing: border-box;
								margin-right: 24px;
								cursor: pointer;
								position: relative;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&::before {
									content: "";
									width: 0%;
									height: 2px;
									background: #ff0e25;
									position: absolute;
									bottom: -2px;
									left: 50%;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
									transform: translateX(-50%);
									-moz-transform: translateX(-50%);
									-webkit-transform: translateX(-50%);
									-o-transform: translateX(-50%);
								}

								&:hover {
									color: #ff0e25;
								}

								&:hover::before {
									width: 100%;
								}

								&.active {
									font-weight: 600;
									color: #ff0e25;
								}

								&.active:before {
									width: 100%;
								}
							}

							& li:last-child {
								margin-right: 0;
							}
						}

						.ttshop-myorderseach {
							float: right;
							position: relative;

							input {
								width: 211px;
								height: 28px;
								border: 1px solid #ebebeb;
								font-size: 12px;
								color: #333;
								padding: 0 70px 0 8px;
								box-sizing: border-box;
								outline: none;
								border-radius: 2px;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:focus {
									border-color: #ff0e25;
								}
							}

							button {
								width: 62px;
								height: 26px;
								display: block;
								font-size: 12px;
								color: #333;
								text-align: center;
								position: absolute;
								top: 1px;
								right: 1px;
								border: 0;
								outline: none;
								background: #ebebeb;
								cursor: pointer;
								border-radius: 0 2px 2px 0;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									background: #ff0e25;
									color: #fff;
								}
							}
						}
					}

					.ttshop-myorderzw {
						width: 100%;
						min-height: 600px;
						background: #fff;
						padding-top: 180px;
						box-sizing: border-box;

						// display: none;
						img {
							display: block;
							width: 93px;
							height: 80px;
							margin: 0 auto 20px;
						}

						p {
							font-size: 14px;
							color: #333;
							text-align: center;
						}
					}

					.ttshop-myorderlist {
						width: 846px;

						.ttshop-myordertitle {
							width: 846px;
							background: #f5f5f5;
							height: 32px;
							margin-bottom: 20px;

							.ttshop-myordertext {
								float: left;
								width: 317px;
								padding-top: 8px;
								padding-left: 20px;
								box-sizing: border-box;

								.ttshop-myordertexter {
									display: table;
									// cursor: pointer;
									width: 297px;
									position: relative;
									div{
										display: flex;
										align-items: center;
										cursor: pointer;
										img{
											width: 12px;
											height: 12px;
										}
									}

									// p {
									// 	float: left;
									// 	font-size: 12px;
									// 	color: #333;
									// }
									select {
										font-size: 12px;
										border: none;
										outline: none;
										color: #999999;
										background: #F5F5F5;
										cursor: pointer;

										option {
											color: #999999;
											outline: none;
											text-indent: 12px;
										}
									}

									i {
										float: left;
										width: 12px;
										height: 12px;
										margin-top: 2px;

										img {
											display: block;
											width: 100%;
										}
									}
								}
							}

							.ttshop-myorderdj {
								float: left;
								width: 90px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}

							.ttshop-myorderdjs {
								float: left;
								width: 76px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}

							.ttshop-myorderzfje {
								float: left;
								width: 98px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}

							// .ttshop_myorderzt {
							//   float: left;
							//   width: 14%;
							//   padding-top: 8px;
							//   box-sizing: border-box;
							//   .ttshop_myorderzts {
							//     // cursor: pointer;
							//     p {
							//       float: left;
							//       font-size: 12px;
							//       color: #333;
							//     }
							//     i {
							//       float: left;
							//       width: 12px;
							//       height: 12px;
							//       margin-top: 2px;
							//       img {
							//         display: block;
							//         width: 100%;
							//       }
							//     }
							//   }
							// }
							.ttshop-myordercz {
								float: right;
								width: 150px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}
						}

						.ttshop-myordercon {
							width: 100%;

							.ttshop-myorderconed {
								width: 100%;
								margin-bottom: 20px;

								.ttshop-myordercontitle {
									width: 100%;
									height: 32px;
									background: #f5f5f5;
									padding: 0 20px;
									box-sizing: border-box;
									line-height: 32px;

									p {
										float: left;
										font-size: 12px;
										color: #999;

										span {
											font-size: 12px;
											color: #999;
										}

										strong {
											color: #333;
											font-weight: 500;
										}
									}

									& p:last-child {
										margin-right: 0;
										// float: right;
									}

									.ttshop-myordercontitle-right {
										float: right;
										line-height: 32px;

										.ttshop-cancel {
											font-size: 12px;
											color: #999;
											// margin-bottom: 2px;
										}

										.ttshop-over {
											font-size: 12px;
											color: #ff0e25;
											margin-right: 24px; 
											// margin-bottom: 2px;
										}
										.ttshop-over-adopt{
											color: green;
										}
										.ttshop-over-examine{
											color: #FF9010;
										}

										strong {
											font-size: 12px;
											color: #ff0e25;
											font-weight: 400;
											cursor: pointer;
										}
									}
								}

								.ttshop-myorderconlist {
									width: 696px;
									min-height: 112px;
									border-left: 1px solid #ebebeb;
									border-bottom: 1px solid #ebebeb;
									box-sizing: border-box;
									border-right: 0;
									border-top: 0;

									.ttshop-myorderconleft {
										float: left;
										width: 50%;
										min-height: 112px;
										padding: 16px 20px 16px 10px;
										box-sizing: border-box;

										.ttshop-orderimg {
											float: left;
											width: 80px;
											height: 80px;
											margin-right: 12px;

											img {
												display: block;
												width: 100%;
												height: 100%;
												object-fit: cover;
											}
										}

										.ttshop-ordertext {
											float: left;
											width: 205px;

											h5 {
												font-size: 12px;
												color: #333333;
												font-weight: 500;
												line-height: 18px;
												display: -webkit-box;
												-webkit-box-orient: vertical;
												-webkit-line-clamp: 2;
												overflow: hidden;
												margin-bottom: 8px;
											}

											span {
												font-size: 12px;
												color: #999;
												margin-right: 5px;

												strong {
													font-weight: 400;
													font-size: 12px;
													color: #999;
												}
											}
										}
									}

									.ttshop-myorderdj {
										float: left;
										width: 11%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;

										p {
											font-size: 12px;
											color: #333;

											span {
												font-size: 12px;
												color: #333;
											}
										}
									}

									.ttshop-myorderdjer {
										border-right: 1px solid #ebebeb;
									}

									.ttshop-shr {
										float: left;
										width: 12%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;
										border-right: 1px solid #ebebeb;

										p {
											font-size: 12px;
											color: #333;
										}
									}

									.ttshop-zfzje {
										float: left;
										width: 16%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;
										border-right: 1px solid #ebebeb;

										p {
											font-size: 12px;
											color: #333;
											margin-bottom: 8px;

											span {
												font-size: 12px;
												color: #333;
											}
										}

										strong {
											font-size: 12px;
											color: #333;
											font-weight: 400;
											cursor: pointer;
											transition: 0.5s;
											-moz-transition: 0.5s;
											-webkit-transition: 0.5s;
											-o-transition: 0.5s;

											&:hover {
												color: #ff0e25;
											}
										}
									}

									// .ttshop_qbzt {
									//   float: left;
									//   width: 15%;
									//   text-align: center;
									//   padding-top: 16px;
									//   min-height: 138px;
									//   box-sizing: border-box;
									//   border-right: 1px solid #ebebeb;
									//   .ttshop_wfk {
									//     font-size: 12px;
									//     color: #ff8500;
									//     margin-bottom: 2px;
									//   }
									//   .ttshop_cancel {
									//     font-size: 12px;
									//     color: #999;
									//     margin-bottom: 2px;
									//   }
									//   .ttshop_over {
									//     font-size: 12px;
									//     color: #333;
									//     margin-bottom: 2px;
									//   }
									//   strong {
									//     font-size: 12px;
									//     color: #ff0e25;
									//     font-weight: 400;
									//     cursor: pointer;
									//   }
									// }

									.ttshop-caozuo {
										float: left;
										width: 16%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;
										border-right: 1px solid #ebebeb;

										.ttshop-ljzf {
											display: block;
											width: 72px;
											height: 24px;
											border: 1px solid #ff3346;
											background: #fff0f1;
											line-height: 24px;
											text-align: center;
											font-size: 12px;
											color: #ff0e25;
											margin: 0 auto 8px;
											border-radius: 2px;
											cursor: pointer;
										}

										.ttshop-cztext {
											font-size: 12px;
											color: #333;
											margin-bottom: 8px;
											cursor: pointer;
											transition: 0.5s;
											-moz-transition: 0.5s;
											-webkit-transition: 0.5s;
											-o-transition: 0.5s;

											&:hover {
												color: #ff0e25;
											}
										}

										.ttshop-hg {
											display: block;
											width: 72px;
											height: 24px;
											background: #ebebeb;
											line-height: 24px;
											text-align: center;
											font-size: 12px;
											color: #999;
											margin: 0 auto 8px;
											border-radius: 2px;
											cursor: pointer;
											transition: 0.5s;
											-moz-transition: 0.5s;
											-webkit-transition: 0.5s;
											-o-transition: 0.5s;

											&:hover {
												background: #ff0e25;
												color: #fff;
											}
										}

										.ttshop-queren {
											display: block;
											width: 72px;
											height: 24px;
											background: #ff0e25;
											line-height: 24px;
											text-align: center;
											font-size: 12px;
											color: #fff;
											margin: 0 auto 8px;
											border-radius: 2px;
											cursor: pointer;
										}
									}
								}
							}

							.ttshop-caozuos {
								float: right;
								width: 24%;
								text-align: center;
								padding-top: 16px;
								min-height: 112px;
								box-sizing: border-box;
								border-right: 1px solid #ebebeb;
								border-bottom: 1px solid #ebebeb;

								.ttshop-agree {
									width: 72px;
									height: 24px;
									line-height: 24px;
									background: rgba($color: #3FD44C, $alpha: 0.3);
									border-radius: 2px;
									border: 1px solid #3FD44C;
									font-size: 12px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									color: #17CD27;
									margin-bottom: 8px;
									cursor: pointer;
								}

								.ttshop-refuse {
									width: 72px;
									height: 24px;
									line-height: 24px;
									background: rgba($color: #FF3346, $alpha: 0.3);
									border-radius: 2px;
									border: 1px solid #FF3346;
									font-size: 12px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									color: #FF3346;
									margin-bottom: 8px;
									cursor: pointer;
								}


								.ttshop-cztexts {
									font-size: 12px;
									color: #ff0e25;
									margin-bottom: 8px;
								}

								.ttshop-ljzf {
									display: block;
									width: 72px;
									height: 24px;
									border: 1px solid #ff3346;
									background: #fff0f1;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #ff0e25;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
								}

								.ttshop-cztext {
									font-size: 12px;
									color: #333;
									margin-bottom: 8px;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										color: #ff0e25;
									}
								}

								.ttshop-hg {
									display: block;
									width: 72px;
									height: 24px;
									background: #ebebeb;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #999;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										background: #ff0e25;
										color: #fff;
									}
								}

								.ttshop-queren {
									display: block;
									width: 72px;
									height: 24px;
									background: #ff0e25;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #fff;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
								}
							}
						}

						.ttshop-myorderpage {
							width: 100%;
							margin-top: 32px;

							.ttshop-pages {
								float: right;
							}
						}
					}
				}
			}
		}
	}


	// 订单审批
	.addpersonal {
		background: #EBEBEB;

		.add-per {
			background: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;

			.add-per-text {
				box-sizing: border-box;
				width: 420px;
				height: 109px;
				resize: none;
				border: 1px solid #EBEBEB;
				padding-top: 8px;
				padding-left: 12px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 12px;
				outline: none;
			}
		}

		.newly-build {
			width: 108px;
			height: 32px;
			margin: 0 auto;
			background: #FF0E25;
			border-radius: 2px;
			font-size: 12px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #FFFFFF;
			line-height: 32px;
			text-align: center;
			margin-top: 32px;
			cursor: pointer;
		}
	}
</style>
